import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconModule } from '@iota/iota-ui-components';
import { MagicSearchRow } from '../../models/magic-search.model';

@Component({
    selector: 'app-magic-search-result-row',
    standalone: true,
    imports: [CommonModule, RouterLink, IconModule],
    templateUrl: './magic-search-result-row.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'block' }
})
export class MagicSearchResultRowComponent {
    readonly row = input.required<MagicSearchRow>();
    readonly selected = input(false);
    readonly activate = output<void>();
}
